import { ENDPOINTS, useActions } from 'hammock';

export const useSegmentDocumentActions = () => {
  const { create, delete: deleteAction, update, action } = useActions(
    ENDPOINTS.contentSegmentDocument,
  );

  const createSegment = (body) =>
    create({
      body,
      invalidates: {
        [ENDPOINTS.contentPublishStatus]: { id: body.contentId },
        [ENDPOINTS.contentSegments]: { id: body.contentId },
        [ENDPOINTS.contentMetadata]: { id: body.contentId },
      },
      onSuccessNotification: { message: 'Successfully Linked Segment' },
    });

  const updateSegment = (body, id) =>
    update({
      id,
      body,
      invalidates: {
        [ENDPOINTS.contentPublishStatus]: { id: body.contentId },
        [ENDPOINTS.contentSegments]: { id: body.contentId },
        [ENDPOINTS.contentMetadata]: { id: body.contentId },
      },
      onSuccessNotification: { message: 'Successfully Updated Segment' },
    });

  const deleteSegment = ({
    id,
    contentId,
    onSuccessNotification = { message: 'Successfully Removed Segment' },
  }) =>
    deleteAction({
      id,
      invalidates: {
        [ENDPOINTS.contentPublishStatus]: { id: contentId },
        [ENDPOINTS.contentSegments]: { id: contentId },
      },
      onSuccessNotification,
    });

  const retargetSegment = (body) =>
    action({
      name: 'moveSegmentDocument',
      body,
      invalidates: {
        [ENDPOINTS.contentPublishStatus]: { id: body.contentId },
        [ENDPOINTS.contentSegments]: { id: body.contentId },
        [ENDPOINTS.contentMetadata]: { id: body.contentId },
      },
      onSuccessNotification: { message: 'Segment Successfully Retarget' },
    });

  return { createSegment, deleteSegment, updateSegment, retargetSegment };
};
